<div class="p-3">
  <mat-card class="approverCard" *ngIf="onlineApprovers?.length">
    <div
      matTooltip="Online Approvers"
      i18n-matTooltip="@@dpr.dprCardApprovers.attrOnlineApprovers"
      class="d-flex align-items-center approverTitle"
    >
      <mat-icon svgIcon="gesture-draw-line" class="mr-1"></mat-icon>
      <span [attr.data-testId]="'approver-name-' + clientName" class="approverName">{{clientName}}</span>
    </div>

    <ng-container
      *ngFor="let onlineApprover of dprOnlineApprovers | sort : 'userName' : 'asc'; trackBy: trackOnlineApprover"
    >
      <button
        [attr.data-testId]="'open-online-approve-' + onlineApprover.userName"
        mat-button
        color="primary"
        class="d-flex approverButton"
        *ngIf="(isLocked && (onlineApprover?.dprOnlineApproval || onlineApprover?.isCurrentUser)); else displayOnlineApproverTemplate"
        (click)="openOnlineApproveModal(onlineApprover)"
      >
        <mat-icon
          class="mr-2"
          [class]="'icon--' + (onlineApprover?.dprOnlineApproval | approveStatusColor : 'approveStatus')"
          [svgIcon]="onlineApprover?.dprOnlineApproval | approveStatusIcon : 'approveStatus'"
        ></mat-icon>
        <span class="approverButtonText">{{onlineApprover.userName}}</span>
      </button>
      <ng-template #displayOnlineApproverTemplate>
        <div
          [attr.data-testId]="'approver-name-' + onlineApprover.userName"
          class="d-flex align-items-center approverNameContainer"
        >
          <mat-icon
            class="mr-2"
            [class]="'icon--' + (onlineApprover?.dprOnlineApproval | approveStatusColor : 'approveStatus')"
            [svgIcon]="onlineApprover?.dprOnlineApproval | approveStatusIcon : 'approveStatus'"
          ></mat-icon>
          {{onlineApprover.userName}}
        </div>
      </ng-template>
    </ng-container>
  </mat-card>

  <ng-container *ngFor="let approver of approvers; trackBy: trackApprover">
    <mat-card class="approverCard" [attr.data-testId]="'print-signer-section-' + displayId">
      <div class="d-flex justify-content-between align-items-center">
        <div
          matTooltip="Print Signers"
          i18n-matTooltip="@@dpr.dprCardApprovers.attrPrintSigners"
          class="d-flex align-items-center approverTitle"
        >
          <mat-icon svgIcon="fountain-pen-tip-line" class="mr-1"></mat-icon>
          <span [attr.data-testId]="'print-signer-' + approver.name" class="approverName">{{approver.name}}</span>
        </div>
        <button
          *ngIf="canEdit && !isLocked && !(addedDprApprovers | getMapValue : approver.id)"
          mat-flat-button
          data-testId="add-approver"
          color="secondary"
          class="button--square button--xsmall"
          matTooltip="Add approver"
          i18n-matTooltip="@@dpr.dprCardApprovers.attrAddApprover"
          (click)="addDprApproverItem(approver.id)"
        >
          <mat-icon svgIcon="plus"></mat-icon>
        </button>
        <button
          *ngIf="canEdit && !isLocked && (addedDprApprovers | getMapValue : approver.id)"
          mat-flat-button
          data-testId="remove-approver"
          color="secondary"
          class="button--square button--xsmall"
          matTooltip="Remove added approver"
          i18n-matTooltip="@@dpr.dprCardApprovers.attrRemoveAddedApprover"
          (click)="removeDprApproverItem(approver.id)"
        >
          <mat-icon svgIcon="close"></mat-icon>
        </button>
      </div>

      <app-dpr-approver
        *ngIf="(addedDprApprovers | getMapValue : approver.id)"
        [dprApprover]="(addedDprApprovers | getMapValue : approver.id)"
        [canEdit]="canEdit && !isLocked"
        [isEditMode]="true"
        [approverSaved$]="approverSaved$.asObservable()"
        (save)="onSaveDprApprover($event)"
        (delete)="onDeleteDprApprover($event)"
      ></app-dpr-approver>
      <ng-container *ngIf="dprApprovers$ | async as dprApprovers">
        <app-dpr-approver
          *ngFor="let dprApprover of (dprApprovers | filterByProperty : 'approverId' : approver.id); trackBy: trackDprApprover"
          [dprApprover]="dprApprover"
          [canEdit]="canEdit && !isLocked"
          [approverSaved$]="approverSaved$.asObservable()"
          (save)="onSaveDprApprover($event)"
          (delete)="onDeleteDprApprover($event)"
        ></app-dpr-approver>
      </ng-container>
    </mat-card>
  </ng-container>
</div>
